const stats = [
  { icon: 'ri-calendar-check-line', value: '+10 Anos', label: 'de Experiência' },
  { icon: 'ri-map-pin-2-line', value: '2 Países', label: 'Brasil & Argentina' },
  { icon: 'ri-tools-fill', value: '12 Modelos', label: 'de Máquinas' },
  { icon: 'ri-customer-service-2-line', value: 'Suporte', label: 'Técnico Especializado' },
];

export default function StatsBar() {
  return (
    <section className="bg-gray-950 py-10">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-0 md:divide-x md:divide-gray-800">
          {stats.map((stat) => (
            <div key={stat.value} className="flex flex-col items-center text-center md:px-8">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-green-500/10 mb-3">
                <i className={`${stat.icon} text-green-400 text-lg`} />
              </div>
              <span className="text-white font-black text-2xl uppercase leading-none">{stat.value}</span>
              <span className="text-gray-500 text-xs mt-1 uppercase tracking-wide">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
